import { render, staticRenderFns } from "./ConnectAndLatencyAlertsModule.vue?vue&type=template&id=d48cbca2"
import script from "./ConnectAndLatencyAlertsModule.vue?vue&type=script&lang=js"
export * from "./ConnectAndLatencyAlertsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports